// Utility to prevent AWS Cognito hosted-UI redirects from stranding the user
// on an amazonaws.com page — bounce them back to our own /login.
export const preventAWSRedirects = () => {
  const checkAndRedirect = () => {
    const currentUrl = window.location.href;
    if (
      currentUrl.includes("signin.aws.amazon.com") ||
      currentUrl.includes("cognito") ||
      currentUrl.includes("amazonaws.com")
    ) {
      console.log("AWS redirect detected, redirecting to /login");
      window.location.replace("/login");
      return true;
    }
    return false;
  };

  if (checkAndRedirect()) return;

  window.addEventListener("popstate", checkAndRedirect);
  window.addEventListener("beforeunload", (e) => {
    if (checkAndRedirect()) e.preventDefault();
  });

  let lastCheckTime = Date.now();
  const checkInterval = setInterval(() => {
    const now = Date.now();
    if (now - lastCheckTime >= 2000) {
      lastCheckTime = now;
      checkAndRedirect();
    }
  }, 2000);

  return () => {
    clearInterval(checkInterval);
    window.removeEventListener("popstate", checkAndRedirect);
    window.removeEventListener("beforeunload", checkAndRedirect);
  };
};

// Clear all AWS-related localStorage / sessionStorage / cookies.
export const clearAllAWSState = () => {
  try {
    Object.keys(localStorage).forEach((key) => {
      if (key.includes("cognito") || key.includes("amplify") || key.includes("aws")) {
        localStorage.removeItem(key);
      }
    });
  } catch (e) {
    /* localStorage unavailable */
  }
  try {
    Object.keys(sessionStorage).forEach((key) => {
      if (key.includes("cognito") || key.includes("amplify") || key.includes("aws")) {
        sessionStorage.removeItem(key);
      }
    });
  } catch (e) {
    /* sessionStorage unavailable */
  }
};
